<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto">
          <v-row no-gutters>
            <v-chip-group mandatory v-model="statusFilter" active-class="success">
              <span class="caption my-auto">Filtrar:</span>
              <!-- <v-chip class="mx-1" label :value="0">
                Todos
              </v-chip> -->
              <v-chip class="mx-1" label :value="1"> Conectados </v-chip>

              <v-chip class="mx-1" label :value="0"> Desconectados </v-chip>
            </v-chip-group>

            <v-btn height="32" class="ml-3 mt-2" depressed @click="reloadPage" v-bind="attrs" v-on="on">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-row>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1 mt-5 mt-md-10">
      <!-- NO TOCAR. ESTA PAGINACIÓN POR SERVIDOR SI FUNCIONA -->
      <v-data-table
        show-expand
        single-expand
        :search="search"
        :headers="headers"
        :items="agentInfo"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :expanded.sync="expanded"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <!-- <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle> -->
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-badge
                  :bordered="item.online"
                  bottom
                  :color="item.online ? 'success' : 'transparent'"
                  dot
                  offset-x="10"
                  offset-y="10"
                >
                  <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
                    <v-img v-if="item.url_image" :src="item.url_image" alt="Avatar del usuario"></v-img>
                    <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                  </v-avatar>
                </v-badge>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <!-- <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.statusExtension`]="{ item }">
          <v-chip color="transparent" small>
            <!-- <v-icon left small :color="statusColor(item.status)"
              >mdi-radiobox-marked</v-icon
            > -->
            {{ extensionState(item.extension) }}
            <!-- {{ item.extension }} -->
          </v-chip>
        </template>

        <template v-slot:[`item.on_leave`]="{ item }">
          <!-- <v-switch @click="changeOnLeave()"></v-switch> -->
          <v-chip small outlined @click.stop="changeOnLeave(item.id)">
            <!-- <v-icon left small :color="statusColor(item.status)"
              >mdi-radiobox-marked</v-icon
            > -->
            {{ item.on_leave ? "Activado" : "Desactivado" }}
          </v-chip>
        </template>

        <template v-slot:[`item.statusQueue`]="{ item }">
          <v-chip color="transparent" small>
            <v-icon left small :color="item.online !== null && item.connect === 1 ? 'success' : 'grey'"
              >mdi-radiobox-marked</v-icon
            >
            {{ item.online !== null && item.connect === 1 ? "Conectado" : "Desconectado" }}
          </v-chip>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <!-- Pausa -->
          <v-chip
            v-if="item.status == 2"
            color="transparent"
            small
            @click.stop="openConfirmClose(item.user_pause[0].id)"
          >
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>

          <!-- Bloqueado -->
          <v-chip v-else-if="item.status == 3" color="transparent" small @click.stop="UnlockAgent(item.lock_user.id)">
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>

          <!-- Documentacion -->
          <v-chip
            v-else-if="item.status == 4"
            color="transparent"
            small
            @click.stop="openConfirmClose(item.user_pause[0].id, item.status)"
          >
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>

          <v-chip v-else color="transparent" small>
            <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
            {{ item.status | StatusName }}
          </v-chip>
        </template>

        <template v-slot:[`item.extension`]="{ item }">
          <span :class="[item.extension === null ? 'text--secondary' : '']">{{
            item.extension !== null ? item.extension : item.extension_opcional ? item.extension_opcional : item.variable
          }}</span>
          <v-icon v-if="item.variable" small class="ml-1" color="grey">mdi-dice-3</v-icon>
        </template>

        <template v-slot:[`item.duration`]="{ item }">
          <span>{{ findDurationByExt(item.extension) }}</span>
        </template>

        <template v-slot:[`item.pauseTime`]="{ item }">
          <span>{{ getTimeTillNowFromItem(item) }}</span>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-tooltip color="blue-grey" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                  @click.stop="handleLogoutPlanta(item.id, item.name)"
                >
                  <v-icon>mdi-connection</v-icon>
                </v-btn>
              </template>
              <span>Desconectar de planta</span>
            </v-tooltip>
          </v-hover>

          <v-hover v-if="item.online !== null && item.connect === 0" v-slot:default="{ hover }">
            <v-tooltip color="blue-grey" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                  @click.stop="handleLogoutSystem(item.id, item.name)"
                >
                  <v-icon>mdi-exit-to-app</v-icon>
                </v-btn>
              </template>
              <span>Cerrar sesión</span>
            </v-tooltip>
          </v-hover>

          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="handleDelete(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover> -->
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-container>
              <v-alert
                v-if="item.online !== null"
                dense
                icon="mdi-account"
                text
                :type="item.connect === 1 ? 'success' : 'warning'"
              >
                <v-row dense justify="space-between" align="center">
                  <v-col v-if="item.connect === 1" class="py-0">
                    Usuario conectado a la planta.
                  </v-col>

                  <v-col v-else class="py-0">
                    Usuario conectado sin conexión a la planta.
                  </v-col>

                  <v-col col="12" md="auto" class="text-left text-md-right py-0">
                    <small>
                      Fecha de conexión:
                      {{ dateFormat(item.online.created_at) }}
                      {{ item.online.created_at | getHourFormat }}
                    </small>
                  </v-col>
                </v-row>
              </v-alert>

              <v-row>
                <v-col cols="12" md="1">
                  <p class="font-weight-medium primary--text mb-1">ID</p>
                  {{ item.id }}
                </v-col>

                <v-col cols="12" md="3">
                  <p class="font-weight-medium primary--text mb-1">
                    Correo electrónico
                  </p>
                  {{ item.email }}
                </v-col>

                <v-col>
                  <p class="font-weight-medium primary--text mb-1">Colas</p>
                  <v-row dense>
                    <v-col cols="auto" class="py-0" v-for="(queue, index) in item.queues" :key="index">
                      <v-chip label class="mr-2 mb-2">
                        {{ `${queue.name} (${queue.number})` }}
                      </v-chip>
                    </v-col>
                    <v-col cols="auto" class="py-0" v-for="(queue, index) in item.queues" :key="index">
                      <v-chip label class="mr-2 mb-2">
                        {{ `${queue.name} (${queue.number})` }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <!-- Componentes -->
    <btnupdate
      v-if="active"
      type="AgentList"
      :data="editUser"
      :active="active"
      @dialog:change="eventdialog"
    ></btnupdate>

    <!-- DESBLOQUEAR AGENTE -->
    <v-dialog v-model="showComment" persistent scrollable max-width="500">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Añadir comentario
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense>
                <v-col cols="12">
                  <v-textarea
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    name="comment"
                    label="Comentario"
                    v-model="comment"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="showComment = false"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="unlockConfirm"
              >Continuar</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- QUITAR PAUSA -->
    <v-dialog :value="isConfirmDialog" @click:outside="isConfirmDialog = false" max-width="500">
      <v-card>
        <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Cerrar Pausa
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text style="max-height: 350px">
          <v-row dense>
            <v-col cols="12">
              <p class="font-weight-medium text-h6">
                Esta seguro que desea cerrar esta pausa
                {{ selectedUserStatus === 4 ? "de documentación" : "" }}?
              </p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="isConfirmDialog = false">
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="error"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="closePause()"
            >
              Confirmar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
import btnupdate from "@/components/Users/User/btnupdate.vue";
import { getTimeTillNow } from "@/components/Utils/timeHelpers";

const BASE_COLUMNS = [
  {
    text: "",
    align: "left",
    value: "data-table-expand",
    width: "5%",
  },
  {
    text: "Agente",
    align: "left",
    value: "name",
    class: "primary--text",
    width: "15%",
  },
  {
    text: "Extensión",
    value: "extension",
    class: "primary--text",
    width: "10%",
  },
  {
    text: "Inicio jornada",
    value: "online_data.created_at",
    class: "primary--text",
    width: "15%",
  },
  {
    text: "Estado cola",
    value: "statusQueue",
    class: "primary--text",
    width: "10%",
  },
  {
    text: "Estado extensión",
    value: "statusExtension",
    class: "primary--text",
    width: "15%",
  },
  {
    text: "Duración",
    value: "duration",
    class: "primary--text",
    align: "center",
    width: "10%",
  },
  {
    text: "Estado agente",
    value: "status",
    class: "primary--text",
    width: "10%",
  },
  {
    text: "Tiempo de pausa",
    value: "pauseTime",
    class: "primary--text",
    width: "10%",
  },
  {
    text: "Acciones",
    value: "action",
    class: "primary--text",
    width: "15%",
    align: "left",
    sortable: false,
  },
  // {
  //   text: "Colas",
  //   value: "role.name",
  //   class: "primary--text",
  //   width: "15%"
  // },
];

export default {
  name: "AgentList",

  components: {
    btnupdate,
  },

  data() {
    return {
      isLoading: false,
      statusFilter: 1,
      search: "",
      expanded: [],
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: -1,
      },
      // End for pagination
      agentInfo: [],
      newExtensionList: [],
      agentInfoBackup: [],
      active: false,
      editUser: {},

      // DESBLOQUEAR AGENTE
      Agent: {},
      comment: "",
      showComment: false,
      // DESPAUSAR AGENTE
      pauseToDelete: null,
      selectedUserStatus: null,
      isConfirmDialog: false,
      breaksList: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.getAgents();
      },
      deep: true,
    },

    statusFilter() {
      this.getAgents();
      this.getNewExtensionList();
    },
  },

  computed: {
    breaks() {
      return this.$store.getters["breaks/GET_BREAK_LOCK"];
    },
    headers() {
      if (!this.hasWhatsappConfig) return BASE_COLUMNS;

      const onLeaveColumnIdx = 8;

      const columns = [
        ...BASE_COLUMNS.slice(0, onLeaveColumnIdx),
        {
          text: "Ausencia",
          value: "on_leave",
          class: "primary--text",
          align: "center",
          width: "10%",
        },
        ...BASE_COLUMNS.slice(onLeaveColumnIdx),
      ];

      return columns;
    },

    hasWhatsappConfig() {
      return this.$store.getters["passport/HAVE_WHATSAPP_CONFIG"];
    },
  },

  async created() {
    await this.$store.dispatch("passport/CHECK_WHATSAPP_CONFIG");
    await this.getBreaks();
    await this.getBreaks2();

    // this.interval = setInterval(() => {
    //   this.getNewExtensionList();
    // }, 30000);
  },

  mounted() {
    this.getNewExtensionList();
    this.getAgents();
  },

  // beforeDestroy() {
  //   clearInterval(this.interval);
  // },

  methods: {
    getTimeTillNowFromItem(item) {
      const pauseUpdatedAt = item.user_pause[0]?.updated_at;
      if (!pauseUpdatedAt) return "--";
      return getTimeTillNow(pauseUpdatedAt);
    },
    reloadPage() {
      // window.location.reload();
      this.getAgents();
      this.getNewExtensionList();
    },

    statusColor(status) {
      let color;

      switch (status) {
        case 0:
          color = "error";

          break;

        case 1:
          color = "success";

          break;

        case 2:
        case 4:
          color = "light-blue";

          break;

        case 3:
          color = "warning";

          break;
      }
      return color;
    },

    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    extensionState(agentExtension = null) {
      let item = null,
        status;
      // console.log(this.newExtensionList);
      const state = this.newExtensionList.filter((item) => item.ext == agentExtension);

      if (state.length > 0) item = state[0].status;

      switch (item) {
        case "Ring":
          status = "Ring";

          break;

        case "Up":
          status = "En llamada";

          break;

        default:
          status = "Libre";
      }
      // return item;

      return status;
    },

    async getNewExtensionList() {
      try {
        const { data } = await PbxHttpClient.get(`/manager/extension_new`);
        this.newExtensionList = data.data;
      } catch (err) {
        this.$snotify.error("Hubo un error consultando las extensiones.", "¡Error!");
      }
    },

    findDurationByExt(extension) {
      const matchingItem2 = this.newExtensionList.find((item) => item.ext === extension);
      if (matchingItem2) {
        if (matchingItem2.duration) {
          return matchingItem2.duration + "s";
        }
      }

      return "--"; // Si no se encuentra ninguna coincidencia
    },

    // DESBLOQUEAR AGENTE
    UnlockAgent(item) {
      this.showComment = true;
      this.Agent = item;
    },

    async unlockConfirm() {
      const enviar = {
        comment: {
          comment: this.comment,
        },
        id: this.Agent,
      };
      const response = await this.$store.dispatch("breaks/UNLOCK_AGENTS", enviar);
      this.showComment = false;
      alert(response.data.message);

      this.reloadPage();
    },
    //

    // QUITAR PAUSA AGENTE
    openConfirmClose(pauseId, userStatus) {
      this.pauseToDelete = pauseId;
      this.selectedUserStatus = userStatus;
      this.isConfirmDialog = true;
    },

    async getBreaks2() {
      try {
        await this.$store.dispatch("breaks/SHOW_AGENTS_BREAKS_LOCK");
        // console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async getBreaks() {
      try {
        const { data } = await PbxHttpClient.get("/agent/use_pause/");
        // console.log("agents", data.data);
        this.breaksList = data.data;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta", "Error");
        // console.log(error);
      }
      this.isLoadingTable = false;
    },

    async closePause() {
      this.isLoading = true;
      try {
        await PbxHttpClient.put(`/agent/use_pause/${this.pauseToDelete}`);
        this.breaksList = this.breaksList.filter((e) => e.pause_id !== this.pauseToDelete);
        this.pauseToDelete = null;
        this.selectedUserStatus = null;
        this.$snotify.success("Pausa cerrada con éxito.", "¡Hecho!");
        this.isConfirmDialog = false;
        this.reloadPage();
      } catch (err) {
        this.$snotify.error("Hubo un error cerrando la pausa", "Error");
      }

      this.isLoading = false;
    },
    //

    /**
     * Busca la lista de agentes
     *
     * @param {Number} page - Numero de pagina a mostrar
     */
    getAgents() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      axios
        .get(
          `${process.env.VUE_APP_ROOTAPI}/clients/show/agents?page=${page}&itemPerPage=${itemsPerPage}&online=${this.statusFilter}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        )
        .then((res) => {
          this.agentInfo = res.data.data;
          this.agentInfoBackup = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
          this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
        });
    },

    eventdialog(payload) {
      this.active = false;

      if (payload !== "cerrar") {
        const indexupdate = this.agentInfo.findIndex((element) => {
          return element.id === payload.id;
        });
        this.agentInfo.splice(indexupdate, 1, payload);
      }
    },

    async changeStatus(value) {
      // console.log("Prueba", value);
      const conf = confirm("CAMBIAR ESTATUS");
      if (conf) {
        try {
          if (value.status === 2) {
            await this.$store.dispatch("user/QUIT_PAUSE", {
              id: value.user_pause[0].id,
            });
          } else {
            await this.$store.dispatch("user/CHANGE_STATUS", {
              id: value.id,
            });
          }

          this.$snotify.success("Estatus cambiado con éxito.", "¡Hecho!");

          this.getAgents();
        } catch (error) {
          this.$snotify.error("No se pudo cambiar el estado del usuario.", "¡Error!");
          // console.error(error);
        }
      }
    },

    async changeOnLeave(id) {
      // console.log("Prueba", value);
      const conf = confirm("CAMBIAR ESTADO");

      if (conf) {
        try {
          await this.$store.dispatch("user/CHANGE_ON_LEAVE", {
            id: id,
          });
          this.$snotify.success("Cambiado con éxito.", "¡Hecho!");
          this.getAgents();
        } catch (error) {
          this.$snotify.error("No se pudo cambiar el estado del usuario.", "¡Error!");
          // console.error(error);
        }
      }
    },

    handleEdit(user) {
      if (user.connect === 1) {
        this.$snotify.warning("No se puede editar un usuario conectado.", "Espera");
      } else {
        this.editUser = {
          id: user.id,
          name: user.name,
          email: user.email,
          extension: user.extension,
          variable: user.variable,
          queues: user.queues,
          priority_order: user.priority_order,
          // password: user.password,
          role_id: user.role_id,
          auto_connection: user.auto_connection,
          extension_opcional: user.extension_opcional,
        };
        this.active = true;
      }
    },

    async handleLogoutPlanta(id, name) {
      const accessToken = localStorage.getItem("token");

      const confirmRequest = await this.$swalconfirm("Logout", `Está seguro de cerrar sesión a ${name}.`);

      if (confirmRequest.isConfirmed) {
        axios
          .get(`${process.env.VUE_APP_ROOTAPI}/authServer/desconnect/${id}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              for (const client of res.data) {
                switch (client.codigo) {
                  case "Command":
                    this.$snotify.error(`Cola ${client.queue}: ${client.message}`, "¡Error!");

                    break;

                  case "Removed":
                    this.$store.commit("passport/UPDATE_CONNECTION_AGENT", 0);

                    this.$snotify.success(`${client.message}`, `Cola ${client.queue}`);

                    break;
                }
              }
              this.getAgents();
            }
          })
          .catch(() => {
            // console.error(error);
            this.$snotify.error("No se pudo desconectar de la planta.", "Error");
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    async handleLogoutSystem(id) {
      const accessToken = localStorage.getItem("token");
      axios
        .post(`${process.env.VUE_APP_ROOTAPI}/assistance/logoutAdmin/${id}`, "", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then(() => {
          this.getAgents();
          this.$snotify.success("Sesión finalizada.", "¡Hecho!");
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("No se pudo cerrar sesión de este usuario.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
